import { css } from '@/styled-system/css';

export const applicationPermissionsHeadingStyles = css({
  margin: '32px 0',
});

export const applicationPermissionsTableStyles = css({
  '& td': {
    width: '25%',
  },
});

export const applicationUsersContainerStyles = css({
  marginTop: '32px',
});

export const applicationUsersTableContainerStyles = css({
  border: '1px solid',
  borderColor: 'border.neutral.secondary',
  borderRadius: 'sm',
  marginTop: '32px',
  padding: '400',
});

export const infoIconContainerStyles = css({
  marginLeft: '4px',
});

export const infoIconStyles = css({
  cursor: 'pointer',
  verticalAlign: 'baseline',
});

export const errorContainerStyles = css({
  margin: '12px 0',
});

export const errorStyles = css({
  color: 'text.critical',
});

export const applicationManagerTableStyles = css({
  marginTop: '20px',
});

export const userInitialStyles = css({
  alignItems: 'center',
  backgroundColor: 'bg.neutral.secondary',
  borderRadius: '50%',
  display: 'flex',
  height: '32px',
  justifyContent: 'center',
  marginRight: '400',
  width: '32px',
});
